import { useAuth } from '@features/auth/hooks/useAuth';
import { useClubRoles } from '@features/auth/hooks/useClubRoles';
import { useClubCardQuery } from '@features/club/api/hooks';
import { useStartListPrivateQuery, useStartListTeamQuery } from '@features/tournament/api/hooks';
import { useTournamentCtx } from '@features/tournament/providers/TournamentProvider';
import { StartList } from '@features/tournament/ui/components/StartList/StartList';
import { StartListSkeleton } from '@features/tournament/ui/components/StartList/StartListSkeleton';
import { PlayerShieldQuickPeekWidget } from '@features/user/ui/PlayerShieldQuickPeek/PlayerShieldQuickPeekWidget';

export function StartListWidget() {
  const { state } = useTournamentCtx();
  const { tournament, clubId, tournamentId } = state;

  const { user } = useAuth();

  const { data: club } = useClubCardQuery(clubId, { staleTime: Infinity });

  const isTeam = tournament?.mode === 'Team' || tournament?.mode === 'TwoOnTwo';
  const { isManager } = useClubRoles(clubId);

  const teamQuery = useStartListTeamQuery(clubId, tournamentId, isTeam);
  const privateQuery = useStartListPrivateQuery(clubId, tournamentId, !isTeam);

  const rows = isTeam ? teamQuery.data : privateQuery.data;
  const isPending = isTeam ? teamQuery.isPending : privateQuery.isPending;

  const skeletonRowCount = isTeam
    ? (tournament?.teamsCount ?? 10)
    : (tournament?.participantsCount ?? 10);

  if (!rows && isPending) {
    return <StartListSkeleton rowCount={skeletonRowCount} isTeam={isTeam} />;
  }

  return (
    <StartList
      rows={rows}
      isManager={isManager}
      isRcf={tournament?.rcfRankCalculated}
      highlightedUserId={user?.userId}
      groupTitle={club?.groupTitle ?? undefined}
      renderShieldQuickPeek={(userId: string) => <PlayerShieldQuickPeekWidget userId={userId} />}
    />
  );
}
